import { ExploreMap } from "./ExploreMap";

type ExploreCompound = {
  Map: typeof ExploreMap;
};

/** The explore tab's parts. Each renders nothing on other tabs. */
export const Explore: ExploreCompound = {
  Map: ExploreMap,
};
